import React, { Component } from 'react'
import PropTypes from 'prop-types'

export class RegularDropdown extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: false
      // selected: '選択して下さい'
    }
  }
  // shouldComponentUpdate (nextProps, nextState) {
  //   if (
  //     this.state.isOpen !== nextState.isOpen ||
  //     this.state.selected !== nextState.selected
  //   ) {
  //     return true
  //   } else {
  //     return false
  //   }
  // }

  _renderDropdownList () {
    return (
      <ul className={ this.state.isOpen ? 'opened' : 'closed' }>
        {
          this.props.choices.map(choice => {
            return <li key={choice} data-selected={choice} onClick={this._handleDropdownClick.bind(this)}>{choice}</li>
          })
        }
      </ul>
    )
  }

  _toggleDropdown () {
    this.setState({ isOpen: !this.state.isOpen })
  }

  _handleDropdownClick (e) {
    const selectedTerm = e.currentTarget.dataset.selected
    // this.setState({ selected: selectedTerm })
    this.props.updateTerm(selectedTerm)
    this._toggleDropdown()
  }

  render () {
    return (
      <div
        className={ `${this.state.isOpen ? 'opened' : 'closed'} dropdown_container`}
        style={this.state.isOpen ? {maxHeight: (this.props.choices.length * 42) + 56} : null}
      >
        <div className="selected flex align-center" onClick={this._toggleDropdown.bind(this)}>
          <span className={ `${this.props.selected !== '選択して下さい' ? 'selection_done' : ''} selected_text` }>{this.props.selected}</span>
          <span className="arrow">▼</span>
        </div>
        { this._renderDropdownList() }
      </div>
    )
  }
}

RegularDropdown.propTypes = {
  updateTerm: PropTypes.func,
  choices: PropTypes.array
}

RegularDropdown.defaultProps = {
  choices: []
}

export default RegularDropdown



// WEBPACK FOOTER //
// ./src/components/_common/RegularDropdown.js